import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { CompanyService } from 'src/app/services/company.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-admin-client-exempt-vendors',
  templateUrl: './admin-client-exempt-vendors.component.html',
  styleUrls: ['./admin-client-exempt-vendors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientExemptVendorsComponent {
  constructor(
    private CompanyService: CompanyService,
    private SharedDataService: SharedDataService,
    private router: Router
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;
              this.SharedDataService.sendEvent(
                'SetTitle',
                `Compliance Exempt Vendors - ${legalName}`
              );
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId?: number;
  SuppliedQueryData: { [key: string]: any } = {
    ExemptVendorId: { $ne: null }
  };

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  actionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    const { ExemptVendorId } = rowData;
    if (action === 'view') {
      this.router.navigate(['admin', 'exempt-vendor', ExemptVendorId, 'info']);
    }
  }
}
